// extracted by mini-css-extract-plugin
export default {"card":"AddMoreCard_card__EGW-H","plus":"AddMoreCard_plus__nxTtt","text":"AddMoreCard_text__iW6VV"};